import Dispatch from "nexia_mobile/flux_like/dispatch";
import { ResourceMap } from "nexia_mobile/framework/resource";

Dispatch.on("RESOURCE_CHANGE_NAME_REQUEST", (resourceHref, newName) => {
  const resource = ResourceMap.findByHref(resourceHref);
  if (!resource) {
    throw new Error(
      `RESOURCE_CHANGE_NAME_REQUEST handler couldn't find resource with href ${resourceHref}`
    );
  }
  const currentName = resource.get("name");
  const xhr = resource.save({ name: newName });
  if (xhr) {
    // backbone.save returns false if resource is invalid
    Dispatch("SHOW_SPINNER");
    xhr
      .catch(() => {
        resource.set({ name: currentName });
      })
      .then(() => Dispatch("HIDE_SPINNER"));
  }
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/resource.js